import { useState } from "react"
import rest from "../../rest"
import { DepartamentoType } from "../../stores/useStoreProfile/types"
import { Relato } from "./type"
import { v4 as uuidv4 } from 'uuid'


export const newStore = (departamento?: DepartamentoType, itemTrabalho?: number): Relato => ({
  key: uuidv4(),
  ultimos_andamentos: '',
  proximos_passos: '',
  necessidade_apoio: '',
  requer_atencao: false,
  departamento: departamento?.id,
  itemtrabalho: itemTrabalho,
  sigla_departamento: departamento?.sigla,
  motivo_devolucao: undefined
})

const useStoreRelato = (initialStore = newStore()) => {
  const [store, _setStore] = useState<Relato>(initialStore)
  const [error, setError] = useState<{ [index: string]: any }>({})
  const [loading, setLoading] = useState('')

  const checkLoading = (action: string) => loading === action

  const setStore = (obj: Relato) => {
    _setStore(Object.assign({}, store, obj))
  }

  const checkError = (field: string) => {
    if (error[field]) {
      const fieldError = error[field]
      if (Array.isArray(fieldError)) {
        return fieldError[0]
      } else {
        return fieldError
      }
    } else {
      return null
    }
  }

  const clearError = () => {
    setError({})
  }

  const get = async (id: number) => {
    try {
      clearError()
      const json = await rest(`reporteandamento/${id}/`)
      _setStore(json)
    } catch (e) {
      setError(e)
    }
  }

  const save = async () => {
    try {
      clearError()
      setLoading('save')
      const json = store.id
        ? await rest(`reporteandamento/${store.id}/`, 'PUT', store)
        : await rest('reporteandamento/', 'POST', store)
      _setStore(json)
      setLoading('')
      return 'Salvo com sucesso'
    } catch (e) {
      setError(e)
      setLoading('')
      throw e
    }
  }

  const excluir = async () => {
    try {
      clearError()
      setLoading('excluir')
      await rest(`reporteandamento/${store.id}/`, 'DELETE')
      setLoading('')
      return 'Excluido com sucesso'
    } catch (e) {
      setError(e)
      setLoading('')
      throw e
    }
  }

  const create = async () => {
    const json = await rest('reporteandamento/', 'POST', store)
    _setStore(json)
    return json
  }

  const enviar = async () => {
    try {
      const action = store.alias_situacao === 'aguardando_revisao'
        ? 'concluir-revisao' : 'enviar'
      clearError()
      setLoading('enviar')
      const relato = action === 'enviar' && !store.id
        ? await create()
        : store
      const json = await rest(`reporteandamento/${relato.id}/${action}/`, 'POST', relato)
      _setStore(json)
      setLoading('')
      return 'Enviado com sucesso'
    } catch (e) {
      setError(e)
      setLoading('')
      throw e
    }
  }

  const solicitarRevisao = async (motivoDevolucao?: string | number) => {
    try {
      clearError()
      setLoading('solicitarRevisao')
      const json = await rest(`reporteandamento/${store.id}/solicitar-revisao/`, 'POST',
        { ...store, motivo_devolucao: motivoDevolucao }
      )
      _setStore(json)
      setLoading('')
      return 'Devolvido com sucesso'
    } catch (e) {
      setError(e)
      setLoading('')
      throw e
    }
  }

  const validar = async () => {
    try {
      clearError()
      setLoading('validar')
      const json = await rest(`reporteandamento/${store.id}/validar/`, 'POST', store)
      _setStore(json)
      setLoading('')
      return 'Validado com sucesso'
    } catch (e) {
      setError(e)
      setLoading('')
      throw e
    }
  }

  const devolver = async (motivoDevolucao?: string | number) => {
    try {
      clearError()
      setLoading('devolver')
      const json = await rest(`reporteandamento/${store.id}/devolver/`, 'POST',
        { ...store, motivo_devolucao: motivoDevolucao }
      )
      _setStore(json)
      setLoading('')
      return 'Devolvido com sucesso'
    } catch (e) {
      setError(e)
      setLoading('')
      throw e
    }
  }

  const api = {
    setStore,
    checkError,
    get,
    save,
    excluir,
    enviar,
    solicitarRevisao,
    validar,
    devolver,
    checkLoading
  }

  return ({ store, api })
}

export default useStoreRelato
